import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProjectRoutePage } from "@/features/project/project-route-page";
import { projectSelectRoute } from "@/lib/app-routes";

const searchSchema = z.object({
  panel: z.enum(["files", "chat", "explorer"]).optional(),
  cmdk: z.literal("1").optional(),
  modal: z
    .enum(["org_settings", "user_settings", "project_settings"])
    .optional(),
});

export const Route = createFileRoute("/_authenticated/$orgSlug/$id/")({
  component: ProjectIndexRoute,
  validateSearch: searchSchema,
});

function ProjectIndexRoute() {
  const { orgSlug, id } = Route.useParams();
  return (
    <ProjectRoutePage
      orgSlug={orgSlug}
      projectSlug={id}
      noFileRoutePath={projectSelectRoute}
    />
  );
}
